import { render, staticRenderFns } from "./SeatData.vue?vue&type=template&id=1d183178&scoped=true&"
import script from "./SeatData.vue?vue&type=script&lang=ts&"
export * from "./SeatData.vue?vue&type=script&lang=ts&"
import style0 from "./SeatData.vue?vue&type=style&index=0&id=1d183178&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d183178",
  null
  
)

export default component.exports